'use strict';

var EnsembleVideo = EnsembleVideo || {};

EnsembleVideo.SocialSharing = function (containerId, settings) {
    this.id = Math.floor(Math.random() * (100 - 1 + 1)) + 1;
    this.container = document.getElementById(containerId);
    this.listClass = "ensembleVideoShare soc";
    this.settings = {
        url: encodeURIComponent(settings.url != null ? settings.url : ''),
        title: encodeURIComponent(settings.title != null ? settings.title : ''),
        summary: encodeURIComponent(settings.summary != null ? settings.summary : ''),
        imageUrl: encodeURIComponent(settings.imageUrl != null ? settings.imageUrl : ''),
        security: JSON.parse(settings.security)
    };
};

EnsembleVideo.SocialSharing.prototype = function () {
    var templates = [
        {
            name: 'evMail',
            url: 'mailto:?subject={TITLE}&body={URL}%0D%0A%0D%0A{SUMMARY}',
            cssclass: 'soc-email1',
            sameWindow: true,
            title: 'Mail',
            security: 'Email'
        },
        {
            name: 'evCopyLink',
            url: '',
            cssclass: 'soc-link1',
            height: 420,
            width: 550,
            isCopyLink: true,
            title: 'Copy Link',
            security: 'CopyUrl'
        },
        {
            name: 'evFacebook',
            url: '//www.facebook.com/sharer/sharer.php?u={URL}',
            cssclass: 'soc-facebook',
            height: 306,
            width: 650,
            title: 'Facebook',
            security: 'Facebook'
        },
        {
            name: 'evTwitter',
            url: '//twitter.com/intent/tweet?text={TITLE}&url={URL}',
            cssclass: 'soc-twitter',
            height: 420,
            width: 550,
            title: 'Twitter',
            security: 'Twitter'
        },        
        {
            name: 'evLinkedIn',
            url: '//www.linkedin.com/shareArticle?mini=true&url={URL}&title={TITLE}&summary={SUMMARY}&source={URL}',
            cssclass: 'soc-linkedin',
            height: 570,
            width: 520,
            title: 'LinkedIn',
            security: 'LinkedIn'
        },
        {
            name: 'evPinterest',
            url: '//pinterest.com/pin/create/button/?url={URL}&description={SUMMARY}&media={IMAGE_URL}',
            cssclass: 'soc-pinterest',
            height: 650,
            width: 1024,
            title: 'Pinterest',
            security: 'Pinterest'
        },
        {
            name: 'evWhatsApp',
            url: 'whatsapp://send?text={URL}',
            cssclass: 'soc-whatsapp1',
            height: 420,
            width: 550,
            title: 'WhatsApp',
            security: 'WhatsApp'
        },        
        {
            name: 'evGoogleClassroom',
            url: '',
            cssclass: 'g-sharetoclassroom soc-icon-last',
            isGoogleClassroom: true,
            title: 'Google Classroom',
            security: 'GoogleClassroom'
        }
    ],
        getEmbedUrl = function () {
            var isInIframe = (parent !== window),
                parentUrl = window.location;

            if (isInIframe) {
                parentUrl = document.referrer;
            }

            return encodeURIComponent(parentUrl);
        },
        loadGoogleClassroomResources = function () {
            jQuery.ajax({
                url: "https://apis.google.com/js/platform.js",
                dataType: "script",
                cache: true
            });
        },
        getSecurity = function (arr, prop) {
            return arr[prop];
        },
        create = function () {            
            if (this.container == null)
                return;

            loadGoogleClassroomResources();            

            try {
                var socialShareIconsList = document.createElement('ul');
                socialShareIconsList.className = this.listClass;
                socialShareIconsList.style.listStyleType = "none";
                socialShareIconsList.id = "shareButtonsList" + this.id;
                if (this.settings.url == '')
                    this.settings.url = getEmbedUrl();

                for (var i = 0, len = templates.length; i < len; i++) {
                    var template = templates[i];
                    var shouldShowIcon = getSecurity(this.settings.security, template.security);
                    if (!shouldShowIcon) {
                        continue;
                    }
                    var shareListElement = document.createElement('li');
                    var shareLink = document.createElement('a');
                    shareLink.id = template.name + this.id;
                    shareLink.className = template.cssclass;               
                    shareLink.href = template.url.replace(/{URL}/g, this.settings.url)
                                .replace(/{TITLE}/g, this.settings.title)
                                .replace(/{SUMMARY}/g, this.settings.summary)
                                .replace(/{IMAGE_URL}/g, this.settings.imageUrl);
                    shareLink.setAttribute('template', i);
                    shareLink.setAttribute('data-toggle', 'tooltip');
                    shareLink.setAttribute('title', template.title);


                    if ((template.sameWindow == null || template.sameWindow == false) && !template.isCopyLink) {
                        shareLink.onclick = function () {
                            var id = this.getAttribute("template");
                            var left = (screen.width / 2) - (templates[id].width / 2);
                            var top = (screen.height / 2) - (templates[id].height / 2);
                            window.open(this.href, 'Share', 'width=' + templates[id].width + ',height=' + templates[id].height + ',scrollbars=yes,top=' + top + ', left=' + left);
                            return false;
                        };
                    }
                
                    if (template.isCopyLink != null && template.isCopyLink) {
                        shareLink.href = 'javascript:void(0)';
                        shareLink.setAttribute('copy-url-target', decodeURIComponent(this.settings.url));
                        shareLink.setAttribute('data-copytext', 'Copy Link');
                        shareLink.setAttribute('data-copiedtext', 'Link Copied');                        
                    }

                    if (template.isGoogleClassroom != null && template.isGoogleClassroom) {
                        shareLink.setAttribute('data-url', decodeURIComponent(this.settings.url));
                    }

                    shareListElement.appendChild(shareLink);
                    socialShareIconsList.appendChild(shareListElement);
                }
                this.container.appendChild(socialShareIconsList);
                setupTooltip();
                resizeSocialSharingIFrame();
            } catch (e) {
                console.log(e);
            }
    };

    return {
        Create: create
    };
}();

// Method resizes iframe for share within modal on load and window resize
function resizeSocialSharingIFrame() {
    var iFrameConfig;
    var intervalId = setInterval(function () {

        // if Share content or Share tool icons are not loaded do not set iframe height
        if (jQuery('#ThumbnailImage').height() == 0)
            return;

        clearInterval(intervalId);

        iFrameConfig = setIFrameConfig(jQuery('html').height(), "modalIframe");
        window.parent.postMessage(iFrameConfig, "*");

    }, 250);

    window.onresize = function () {
        iFrameConfig = setIFrameConfig(jQuery('html').height(), "modalIframe");
        window.parent.postMessage(iFrameConfig, "*");
    };
}

// Method creates iFrame config that will be sent to parent window for iFrame responsivness
function setIFrameConfig(iFrameHeight, iFrameId) {
    var iFrameConfig = JSON.stringify({
        iFrameWidth: '100%',
        iFrameHeight: iFrameHeight + 'px',
        iFrameId: iFrameId
    });

    return iFrameConfig;
}

function setupTooltip() {
    jQuery('[data-toggle="tooltip"]').tooltip();

    // On mouse leave set default tooltip
    jQuery(document).on('mouseleave', '.soc-link1', function () {
        var $currentTooltip = jQuery(this);
        $currentTooltip.attr("data-original-title", $currentTooltip.data("copytext"));
    });

    // On click copy link to clipboard and show 'Copied' tooltip
    jQuery(document).on('click', '.soc-link1', function (e) {

        var $currentTooltip = jQuery(this);
        $currentTooltip.attr("data-original-title", $currentTooltip.data("copiedtext"));

        copyToClipboard($currentTooltip);

        $currentTooltip.tooltip('enable').tooltip('show');
        setTimeout(function () {
            $currentTooltip.tooltip('hide').tooltip('disable');
        }, 1000);

    });

    // Copy link to clipboard
    function copyToClipboard($currentTooltip) {
        var $temp = jQuery("<input/>");

        $currentTooltip.parent().append($temp);

        $temp.val($currentTooltip.attr('copy-url-target')).select();
        document.execCommand('copy');
        $temp.remove();
    }
}